import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'telephone',
    standalone: false
})
export class TelephonePipe implements PipeTransform {
	transform(digits : string) {
		if (digits == undefined || digits.length != 10) {
			return digits;
		}
		let area = digits.substring(0,3);
		let pre = digits.substring(3,6);
		let post = digits.substring(6,digits.length);
		return "(" + area + ") " + pre + "-" + post;
	}
}